import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
import router from "./router";
import store from "./store/store";
import Vuebar from "vuebar";
import "./plugins/base";
import VueSkycons from "vue-skycons";
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import stockInit from 'highcharts/modules/stock'
import mapInit from 'highcharts/modules/map'
import addWorldMap from './js/worlmap'
import highchartsMore from 'highcharts/highcharts-more'
import exportingInit from 'highcharts/modules/exporting'
import moment from 'moment'

Vue.prototype.moment = moment
exportingInit(Highcharts);

stockInit(Highcharts)
mapInit(Highcharts)
addWorldMap(Highcharts)
highchartsMore(Highcharts)

Vue.use(HighchartsVue, {Highcharts})

Vue.use(VueSkycons, {
  color: "#1e88e5",
});
//Vue.prototype.$api_url = 'http://sir.diresacajamarca.gob.pe:8050/'
Vue.prototype.$style_table = 'blue'
Vue.prototype.$api_url = 'https://sir.diresacajamarca.gob.pe:8050/'
//Vue.prototype.$api_url = 'http://172.18.20.38:8050/api'
Vue.config.productionTip = false;
Vue.use(Vuebar);

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App),
}).$mount("#app");
